module.exports = __webpack_public_path__ + "assets/gaozhong-silogan-transp.4e60353.png";